module.exports = __webpack_public_path__ + "static/media/m-terraboost.79d4442e.pdf";